<template>
    <div class="igc--popup" v-show="show" ref="igcpopup">
        <div class="pop-wrap" :style="{ 'background': mColor(7) }" >
            <!--头部-->
            <div class="pop-header" :style="{ 'color': mColor(1), 'background': mBackground(8, 'bottom') }" v-if="config.title" v-text="config.title"></div>
            <!--内容-->
            <div class="pop-body" :style="{'padding': nopadding ? '0px' : 'none'}">
                <slot></slot>
            </div>
            <!--尾部-->
            <div class="pop-foot row" :style="{ 'background': mBackground(8, 'top') }">
                <div class="pop-foot-btn col" @click="$emit('cancel')" :style="{ 'color': mColor(1), 'background': mBackground(8, 'right') }" v-text="config.btn1_text||'取消'"></div>
                <div class="pop-foot-btn col" @click="$emit('confirm')" :style="{ 'color': mColor(4) }" v-text="config.btn2_text||'确认'"></div>
            </div>
        </div>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-popup',

    mixins: [mCore],

    props: {
        /**
         * [config description]
         * @title, [String] - 标题 (为空则不显示标题)
         * @btn1_text, [String] - 按钮 1 文本
         * @btn2_text, [String] - 按钮 2 文本
         * @btn1_cb, [String] - 按钮 1 回调
         * @btn2_cb, [String] - 按钮 2 回调
         */
        config: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        nopadding: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {

        }
    },

    mounted() {
        this.$root.$el.appendChild(this.$refs.igcpopup);
    },

    methods: {
        // btn1_cb() {
        //     const btn1_cb = this.config.btn1_cb||(()=>{});
        //     btn1_cb();
        // }, 
        // btn2_cb() {
        //     const btn2_cb = this.config.btn2_cb||(()=>{});
        //     btn2_cb();
        // }
    }
}
</script>

<style lang="postcss">

.igc--popup {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.7);
    z-index: 9999;
    .pop-wrap {
        position: absolute;
        left: 50%;
        /* margin-left: -385px; */
        top:50%;
        transform: translate(-50%, -50%);
        border-radius: 5px;
        min-width: 560px;
        .pop-header {
            text-align: center;
            line-height: 88px;
            font-size: 34px;
            /* border-bottom: solid 1px; */
        }
        .pop-body {
            padding: 30px 60px; 
        }
        .pop-foot {
            text-align: center;
            /* border-top: solid 1px; */
            .pop-foot-btn {
                line-height: 88px;
                font-size: 34px;
            }
            .pop-foot-btn:first-child {
                /* border-right: solid 1px; */
            }
        }
    }
}
</style>
